<template>
<div class='pagination-container'>
  <div class='row-count text-muted' v-if="extendedPagination">
    <div class='select-container'>
      <select v-model="curPerPage" @change="perPageChange(curPerPage)">
        <option v-for="option in perPageArray" :key="option" :value="option">
          {{$t('pagination.show_per_page')}} {{ option }}
        </option>
      </select>
      <span class="selected-value">{{ firstRow }} - {{ lastRow }} ({{ totalRows }})</span>
    </div>
  </div>
  <div class='row-count text-muted' v-else>{{firstRow}} - {{lastRow}} ({{ totalRows}})</div>  
  <div class='pages'>
    <b-pagination
      v-if="totalRows > curPerPage"
      v-model="curPage"
      :total-rows="totalRows"
      :per-page="curPerPage"
      align="fill"
      @input="pageChange"
      first-number
      last-number />
  </div>
</div>
</template>

<script>
export default {
  name: 'TablePagination', 
  props: {
    perPage: {
      type: Number,
      default: 10
    },
    totalRows: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    extendedPagination: {
      type: Boolean,
      default: false
    },
    perPageArray: {
      type: Array,
      default() {
        return [this.perPage, this.perPage*2, this.perPage*3]
      }
    }
  },
  data() {
    return {
      curPage: 1,
      curPerPage: this.perPageArray[0]
    }
  },
  methods: {
    pageChange(page) {
      this.$emit('pageChange', page);
    },
    perPageChange(perPage) {
      this.$emit('perPageChange', perPage);
    }
  }, 
  watch: {
    currentPage: function(val) {
      this.curPage = val;
    }
  },
  computed: {
    firstRow(){
      return Math.min((this.curPage-1) * this.curPerPage + 1, this.totalRows);
    },
    lastRow(){
      return Math.min(this.firstRow + this.curPerPage - 1, this.totalRows);
    },
  }
}
</script>
